var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import Multiselect from 'vue-multiselect';
import { COMPANIES, LOCATIONS, PRODUCTS, SILOS } from '@/queries/admin';
var FilterList = /** @class */ (function (_super) {
    __extends(FilterList, _super);
    function FilterList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.companies = [];
        _this.locations = [];
        _this.products = [];
        _this.silos = [];
        _this.dateSelect = ['Today', 'Yesterday', 'This Week', 'Last Week', 'This Month', 'Last Month', 'This Quarter', 'Last Quarter', 'This Year', 'Last Year', 'All Time'];
        _this.querySelect = ['BOL #', 'PO #', 'Pick Up #', 'Invoice #', 'Equipment ID'];
        _this.originalTimeFrame = 'This Week';
        return _this;
    }
    FilterList.prototype.mounted = function () {
        if (this.options && this.options.showTimeframe && this.options.selectedTimeframe) {
            this.originalTimeFrame = this.options.selectedTimeframe;
        }
    };
    Object.defineProperty(FilterList.prototype, "useLocations", {
        get: function () {
            if (this.options && this.options.altLocations && this.options.altLocations.length) {
                return this.options.altLocations.slice();
            }
            else {
                return this.locations.slice();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterList.prototype, "limitNum", {
        get: function () {
            return this.options.multiple ? 0 : 9999;
        },
        enumerable: true,
        configurable: true
    });
    FilterList.prototype.clearSelection = function () {
        if (this.options.multiple) {
            this.options.selectedSilo = [];
            this.options.selectedLocation = [];
            this.options.selectedProduct = [];
            this.options.selectedCompany = [];
        }
        else {
            this.options.selectedSilo = {};
            this.options.selectedLocation = {};
            this.options.selectedProduct = {};
            this.options.selectedCompany = {};
        }
        if (this.options.showCompany) {
            this.options.company = {};
        }
        if (this.options.showTimeframe) {
            this.options.selectedTimeframe = this.originalTimeFrame;
        }
        if (this.options.showSearch) {
            this.options.searchQuery = '';
            this.options.selectedQuery = 'PO #';
        }
        this.options.changeOptions();
    };
    FilterList = __decorate([
        Component({
            name: 'filter-list',
            components: { Multiselect: Multiselect },
            props: {
                options: {
                    type: Object,
                    required: true
                }
            },
            apollo: {
                companies: {
                    query: function () { return COMPANIES; },
                    fetchPolicy: 'no-cache'
                },
                locations: {
                    query: function () { return LOCATIONS; },
                    fetchPolicy: 'no-cache'
                },
                products: {
                    query: function () { return PRODUCTS; },
                    fetchPolicy: 'no-cache'
                },
                silos: {
                    query: function () { return SILOS; },
                    fetchPolicy: 'no-cache'
                }
            }
        })
    ], FilterList);
    return FilterList;
}(Vue));
export default FilterList;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/FilterList.vue
// module id = 786
// module chunks = 1